"use strict";

var ModelClass = require('./Model'),
    Constants = require('../constants'),
    _ = require('underscore'),
    $ = require('jquery'),
    URI = require('urijs');

var BrochureTemplate = ModelClass.extend({
    url: Constants.restPath + "/agents/brochure",

    idAttribute: 'id',

    defaults: function() {
        return {
            id: undefined,
            name: undefined
        };
    },

    getPreviewURL: function(options) {
        var me = this,
            url = URI(_.result(me, 'url'));

        options = _.extend({
            format: 'pdf'
        }, options || {});

        url = url.addSearch({
            format: options.format,
            template: options.id || me.id,
            listingId: options.listingId
        });

        return url.toString();
    }
});

module.exports = BrochureTemplate;
